export function injectStyles(
  styles: string,
  id: string,
  replacements: Partial<Record<string, string>> = {}
) {
  if (!document.querySelector(`[data-player-plugin="${id}"]`)) {
    const element = document.createElement('style');

    const filledStyles = styles.replace(/__[A-Z_]*__/g, (match) => {
      const key = match.replace(/^__/, '').replace(/__$/, '');
      return replacements[key] || key;
    });

    element.innerHTML = filledStyles;
    element.dataset.playerPlugin = id;

    document.head.appendChild(element);
  }
}

export function addClass(el: Element, className: string) {
  el.className = `${el.className} ${className}`;
}

export function removeClass(el: Element, className: string) {
  el.className = el.className.replace(` ${className}`, '');
}

export function replaceClass(
  el: Element,
  className: string | RegExp,
  replacement: string
) {
  const regexp =
    className instanceof RegExp ? className : new RegExp(className);

  const current = el.className;

  el.className = regexp.test(current)
    ? current.replace(regexp, replacement)
    : `${current} ${replacement}`;
}

export function addListener(
  target: NodeList | Element,
  eventType: string,
  callback: EventListener
) {
  if (target instanceof NodeList) {
    Array.prototype.forEach.call(target, (element: Element) => {
      element.addEventListener(eventType, callback);
    });
  } else {
    target.addEventListener(eventType, callback);
  }
}

export function removeListener(
  target: NodeList | Element,
  eventType: string,
  callback: EventListener
) {
  if (target instanceof NodeList) {
    Array.prototype.forEach.call(target, (element) => {
      element.removeEventListener(eventType, callback);
    });
  } else {
    target.removeEventListener(eventType, callback);
  }
}

export function hydrateTemplate(
  template: string,
  data: Partial<Record<string, string>>
) {
  return Object.keys(data).reduce((result, key) => {
    return result.replace(new RegExp(`<!--= *${key} *-->`, 'g'), data[key]!);
  }, template);
}
